import { ScrollArea } from "../../components/ui/ScrollArea";
import { useIndexSelection } from "../../hooks/useIndexSelection";
import { cn } from "../../utils/cn";
interface IndexOption {
    indexName: string;
    label: string;
}

export interface IndexSelectorProps {
    options: IndexOption[];
    onChange: (newIndex: string, prevIndex: string) => void;
    defaultSelectedIndex: string;
}

export default function IndexSelector({ options, onChange, defaultSelectedIndex }: IndexSelectorProps) {
    const { selectedIndex, selectionHandler, getHitsCount } = useIndexSelection(defaultSelectedIndex, onChange);

    return (
        <section>
            <ScrollArea orientation="horizontal" className="tw-max-w-full tw-pb-3">
                <ul
                    className={cn(
                        "tw-inline-flex tw-space-x-5 xl:tw-block xl:tw-space-x-0",
                        "xl:tw-space-y-2 tw-text-lg xl:tw-text-2xl tw-text-search-grey",
                        "[&>li]:tw-whitespace-nowrap",
                        "[&_.active]:tw-text-black xl:[&_.active]:tw-list-disc [&_.active]:tw-list-inside",
                        "[&_.active_span]:tw-relative xl:[&_.active_span]:-tw-left-4",
                        "tw-border-b border tw-border-search-grey/50 xl:tw-border-0",
                    )}
                >
                    {options.map((option) => {
                        const selected = selectedIndex === option.indexName;
                        const hitsCount = getHitsCount(option.indexName);
                        const isDisabled = !Boolean(hitsCount);

                        return (
                            <li key={option.indexName} className={cn(selected && "active")}>
                                <span>
                                    <button
                                        value={option.indexName}
                                        onClick={() => !isDisabled && selectionHandler(option.indexName)}
                                        className={cn(
                                            isDisabled && "tw-cursor-not-allowed tw-opacity-50 tw-pointer-events-auto",
                                        )}
                                    >
                                        {option.label} ({hitsCount})
                                    </button>
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </ScrollArea>
        </section>
    );
}
